
export const handleUserInfo = (response: any) => {

    const data: dataType = {
        name:  response.name != undefined ? response.name : null,
        email: response.email != undefined ? response.email : null,
        userId:  response.id != undefined ? response.id : null,
        number:  response.number != undefined ? response.number : null,
        countryCode:  response.country_code != undefined ? response.country_code : null,
        emailVerfiy:  response.email_verified_at != undefined ? response.email_verified_at : null,
        userToken: response?.access_token != undefined ? response?.access_token : null,
        storeGroupId:response?.store_group_id != undefined ? response?.store_group_id : null,
        rights:response.rights != undefined ? response.rights : null
    }
    return data;
}


export type dataType = {
    name:string;
    email:string
    userId:number
    number:string
    countryCode:string
    emailVerfiy:boolean
    userToken:string
    storeGroupId:number
    rights:any
}


export const handleStoreInfo = (response: any) => {

    const data: dataTypeForStore = {
        name:  response.name != undefined ? response.name : null,
        email: response.email != undefined ? response.email : null,
        userId:  response.id != undefined ? response.id : null,
        number:  response.number != undefined ? response.number : null,
        countryCode:  response.country_code != undefined ? response.country_code : null,
        emailVerfiy:  response.email_verified_at != undefined ? response.email_verified_at : null,
        userToken: response?.access_token != undefined ? response?.access_token : null,
        storeGroupId:response?.store_group_id != undefined ? response?.store_group_id : null,
        rights:response.rights != undefined ? response.rights : null,
        storeId:response.id != undefined ? response.id : null,
        storeRight:response.right != undefined ? response.right : null,
        storeList:response.stores != undefined ? response.stores : null
    }
    return data;
}

export type dataTypeForStore = {
    name:string;
    email:string;
    userId:number;
    number:string;
    countryCode:string;
    emailVerfiy:boolean;
    userToken:string;
    storeGroupId:number;
    rights:any;
    storeId: number;
    storeRight: any;
    storeList: any;
}